<app-vertical-tab-group>

    <app-vertical-tab
        *ngFor="let treatment of treatments.controls" 
        [title]="'Treatment ' + treatment.value.treatmentNumber"
        [hasError]="treatment.get('plantingInstructions').invalid">

        <div>
            <app-planting-instructions-form [treatment]="treatment" [numberOfSeedsPerCell]="numberOfSeedsPerCell" [isWheatRequest]="isWheatRequest" #plantingForm></app-planting-instructions-form>
        </div>

        <div class="text-right" *ngIf='numberToPotsEnabled || numberToHarvestEnabled'>
            <button class="btn btn-default" type="button" (click)="applyAll(plantingForm)">
                Apply to All
            </button>
        </div>
    </app-vertical-tab>
    
</app-vertical-tab-group>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/planting-instructions/planting-instructions.component.html